import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import './section2.css';
import cronometroImg from '../../assets/cronometro/Cronometro6.svg';
import videoSrc from '../../assets/videos/TesteVideo2.mp4';
import programacaoImg from '../../assets/programacao/Programacao1.svg'; // Importando a imagem

const Section2 = () => {
const eventDate = useMemo(() => new Date(2025, 8, 17, 23, 59), []); 
/*
 const eventDate = useMemo(() => {
  const now = new Date();
  return new Date(now.getTime() + 10 * 1000); // 10 segundos para teste
}, []); 

*/

  const [timeRemaining, setTimeRemaining] = useState({
    days: 0, hours: 0, minutes: 0, seconds: 0
  });

  const [showVideo, setShowVideo] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(false); 
  const videoRef = useRef(null); 

  const calculateTimeRemaining = useCallback(() => {
    const now = new Date();
    const difference = eventDate - now;

    return {
      days: Math.max(0, Math.floor(difference / (1000 * 60 * 60 * 24))),
      hours: Math.max(0, Math.floor((difference / (1000 * 60 * 60)) % 24)),
      minutes: Math.max(0, Math.floor((difference / (1000 * 60)) % 60)),
      seconds: Math.max(0, Math.floor((difference / 1000) % 60))
    };
  }, [eventDate]);

  useEffect(() => {
    const timer = setInterval(() => {
      const updatedTime = calculateTimeRemaining();
      setTimeRemaining(updatedTime);

      if (
        updatedTime.days === 0 &&
        updatedTime.hours === 0 &&
        updatedTime.minutes === 0 &&
        updatedTime.seconds === 0
      ) {
        setShowVideo(true);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [calculateTimeRemaining]);

  // Quando showVideo ou soundEnabled mudarem, atualiza mute do vídeo
  useEffect(() => {
    if (showVideo && videoRef.current) {
      videoRef.current.muted = !soundEnabled; // se soundEnabled=true → muted=false
    }
  }, [showVideo, soundEnabled]);

  const formatNumber = (num) => num.toString().padStart(2, '0');

  return (
    <section className="section2">
      <div className="image-container">
        <img src={cronometroImg} alt="Evento" className="section2-img" />

        <div className="countdown-container">
          <div className="mobile-countdown-message">
            Contagem Regressiva
          </div>

          <div className="countdown-grid">
            <div className="countdown-card">
              <div className="countdown-number glow">{formatNumber(timeRemaining.days)}</div>
              <div className="countdown-label">DIAS</div>
            </div>

            <div className="countdown-separator pulse">:</div>

            <div className="countdown-card">
              <div className="countdown-number glow">{formatNumber(timeRemaining.hours)}</div>
              <div className="countdown-label">HORAS</div>
            </div>

            <div className="countdown-separator pulse">:</div>

            <div className="countdown-card">
              <div className="countdown-number glow">{formatNumber(timeRemaining.minutes)}</div>
              <div className="countdown-label">MINUTOS</div>
            </div>

            <div className="countdown-separator pulse">:</div>

            <div className="countdown-card">
              <div className="countdown-number glow">{formatNumber(timeRemaining.seconds)}</div>
              <div className="countdown-label">SEGUNDOS</div>
            </div>
          </div>

          <div className="countdown-message">
            O evento começa dia <span className="highlight">{eventDate.toLocaleDateString('pt-BR')}</span>
          </div>
        </div>

        {/* IMAGEM DA PROGRAMAÇÃO — FORA DO CONTAINER */}
        <div className="mobile-programacao-wrapper">
          <img
            src={programacaoImg}
            alt="Programação"
            className="mobile-programacao-img"
          />
        </div>

        {showVideo && (
          <div className="video-overlay">
            <video
              ref={videoRef}
              className="section2-video"
              autoPlay
              loop
              muted 
              playsInline
            >
              <source src={videoSrc} type="video/mp4" />
              Seu navegador não suporta o vídeo.
            </video>

            <div className="event-started-text">
              A Nossa Feira Começou!!
            </div>

            {/* BOTÃO sempre visível */}
            <button
              className="unmute-button"
              onClick={() => setSoundEnabled(!soundEnabled)}
            >
              {soundEnabled ? '🔇 Mutar Som' : '🔊 Ativar Som'}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Section2;
